module.exports = __webpack_public_path__ + "static/media/logo-horizontal-nyko2.b6bb2d87.png";